import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./parametros.service";
const _url = environment.ruta;
export class CatalogosService {
    constructor(_http, _valor) {
        this._http = _http;
        this._valor = _valor;
    }
    CatalogoMunicipios() {
        let encabezado = this._valor.FormDataToken();
        return this._http.get(`${_url}Catalogos/Organos/Municipios`, { headers: encabezado }).pipe(map(this.infoDatos));
    }
    CatalogoPartidos() {
        let encabezado = this._valor.FormDataToken();
        return this._http.get(`${_url}Catalogos/Partidos`, { headers: encabezado }).pipe(map(this.infoDatos));
    }
    CatalogoPeticionarios() {
        let encabezado = this._valor.FormDataToken();
        return this._http.get(`${_url}Catalogos/Peticionarios`, { headers: encabezado }).pipe(map(this.infoDatos));
    }
    CatalogoCaracter() {
        let encabezado = this._valor.FormDataToken();
        return this._http.get(`${_url}Catalogos/Caracteres`, { headers: encabezado }).pipe(map(this.infoDatos));
    }
    CatalogoTiposImprocedencia() {
        let encabezado = this._valor.FormDataToken();
        return this._http.get(`${_url}Catalogos/TiposImprocedencias`, { headers: encabezado }).pipe(map(this.infoDatos));
    }
    CatalogoOrgnos() {
        let encabezado = this._valor.FormDataToken();
        return this._http.get(`${_url}Catalogos/Organos`, { headers: encabezado }).pipe(map(this.infoDatos));
    }
    CatalogoTiposPrevenciones() {
        let encabezado = this._valor.FormDataToken();
        return this._http.get(`${_url}Catalogos/TiposPrevenciones`, { headers: encabezado }).pipe(map(this.infoDatos));
    }
    CatalogoArticulos() {
        let encabezado = this._valor.FormDataToken();
        return this._http.get(`${_url}Catalogos/Articulos`, { headers: encabezado }).pipe(map(this.infoDatos));
    }
    CatalogoEjercicios() {
        let encabezado = this._valor.FormDataToken();
        return this._http.get(`${_url}Catalogos/Ejercicios`, { headers: encabezado }).pipe(map(this.infoDatos));
    }
    EsProceso() {
        let encabezado = this._valor.FormDataToken();
        return this._http.get(`${_url}Catalogos/EsProceso`, { headers: encabezado }).pipe(map(this.infoDatos));
    }
    infoDatos(res) {
        let body = res;
        return body.info || {};
    }
}
CatalogosService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CatalogosService_Factory() { return new CatalogosService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ParametrosService)); }, token: CatalogosService, providedIn: "root" });
